














































































import { Component, Vue, Watch } from 'vue-property-decorator'
import List from '@/components/list.vue'
import Tab from '@/components/tab.vue'
import { list, getOwner } from '@/api/task/common'
import { PAGINATION_PARAM, teamStatusList, crowdTypeList, teamRequireList, sortList, partakeList, expRequireList } from '@/global/constants'
import { goTop, isLogin } from '../../global/utils'

@Component({
  components: {
    List,
    Tab
  }
})
export default class Task extends Vue {
  private tabsStatuesList: object[] = teamStatusList
  private tabsTypeList: object[] = crowdTypeList
  private tabsRepuireList: object[] = teamRequireList
  private tabsSortList: object[] = sortList
  private tabsPartakeList: object[] = partakeList
  private tabsExpRequireList: object[] = expRequireList
  private dataList: object = []
  private loading: boolean = false
  private total: number = 0
  private dataOwner: object = []
  private params: object = {
    join: null,
    is_pass_exp: null,
    type: '1',
    step: null,
    sort: '3',
    q: null,
    ...PAGINATION_PARAM
  }
  private created() {
    this.getOwner()
    this.getList(this.params)
  }
  //获取任务发布人
  private async getOwner() {
    try {
      const data: any = await getOwner()
      this.$nextTick(() => {
        this.dataOwner = data ? data : []
      })
    } catch (err) {
      console.log(err)
    }
  }
  // 获取列表数据
  private async getList(params) {
    this.loading = true
    this.dataList = []
    try {
      const data: any = await list(params)
      this.$nextTick(() => {
        this.dataList = data ? data.rows : []
        this.total = data ? data.total : 0
      })
    } catch (err) {
      console.log(err)
    }
    this.loading = false
    goTop()
  }
  //参与状态切换
  private PartakeStatus(data) {
    isLogin(this)
    data = data === '2' ? null : data
    this.params = Object.assign(this.params, { join: data, page: 1 })
    this.getList(this.params)
  }
  //经验值切换
  private expRequire(data) {
    isLogin(this)
    data = data === '2' ? null : data
    this.params = Object.assign(this.params, { is_pass_exp: data, page: 1 })
    this.getList(this.params)
  }
  // 团队是否领取 切换
  private changeStatus(data) {
    isLogin(this)
    data = data === '2' ? null : data
    this.params = Object.assign(this.params, { team_join: data, page: 1 })
    this.getList(this.params)
  }
  // 团队经验值 切换
  private changeRequire(data) {
    data = data === '2' ? null : data
    if (data) {
      // 全部任务不要求登录态
      isLogin(this)
    }
    this.params = Object.assign(this.params, { team_is_pass_exp: data, page: 1 })
    this.getList(this.params)
  }
  // step 切换
  private changeType(data) {
    data = data === '0' ? null : data
    this.params = Object.assign(this.params, { step: data, page: 1 })
    this.getList(this.params)
  }
  // owner 切换
  private changeOwner(data) {
    data = data === '0' ? null : data
    this.params = Object.assign(this.params, { owner: data, page: 1 })
    this.getList(this.params)
  }
  // sort 切换
  private changeSort(data) {
    data = data === '0' ? null : data
    this.params = Object.assign(this.params, { sort: data, page: 1 })
    this.getList(this.params)
  }
  // 搜索
  private handleSearch(data) {
    let path = `/task/search?q=${data}&type=1`
    window.open(path, '_blank')
    // this.getList(Object.assign(this.params, { page: 1 }));
  }
  // 重置
  private clearSearch() {
    ;(this.params as any).q = null
    this.getList(Object.assign(this.params, { page: 1 }))
  }
  // 分页
  public changePage(data) {
    this.params = Object.assign(this.params, { page: data })
    this.getList(this.params)
  }
}
